(function () {
  const ROOT =
    (window.Shopify && Shopify.routes && Shopify.routes.root)
      ? Shopify.routes.root
      : '/';

  function storefrontPath(path) {
    return ROOT.replace(/\/?$/, '/') + String(path || '').replace(/^\/+/, '');
  }

  function normalizeStorefrontUrl(url) {
    const target = new URL(url, window.location.origin);
    const root = ROOT.replace(/\/?$/, '/');

    if (target.origin === window.location.origin && root !== '/' && !target.pathname.startsWith(root)) {
      target.pathname = storefrontPath(target.pathname);
    }

    return target.toString();
  }

  function normalizeAppProxyUrl(url) {
    const raw = String(url || '').trim();
    if (!raw) return '';

    const target = new URL(raw, window.location.origin);

    if (target.origin !== window.location.origin) {
      return target.toString();
    }

    const appsIndex = target.pathname.indexOf('/apps/');
    if (appsIndex >= 0) {
      return target.pathname.slice(appsIndex) + target.search + target.hash;
    }

    return '/' + raw.replace(/^\/+/, '');
  }

  function appProxyUrlCandidates(url) {
    const raw = String(url || '').trim();
    const normalized = normalizeAppProxyUrl(raw);
    // Maschinenrouten duerfen nicht von einer Storefront-Uebersetzung abhaengen.
    // Shopify kann Text-Settings wie "/apps/aufrechnung/check" lokalisieren.
    const candidates = [
      '/apps/aufrechnung/check',
      '/apps/tratter-geo/check',
      normalized
    ];

    if (normalized && normalized.startsWith('/apps/') && ROOT !== '/') {
      candidates.push(storefrontPath(normalized));
    }

    candidates.push(raw);

    return candidates.filter((candidate, index, list) =>
      candidate && list.indexOf(candidate) === index
    );
  }

  function checkoutErrorMessage(data, fallback) {
    if (data && typeof data.message === 'string' && data.message.trim()) {
      return data.message;
    }

    const errors = data && (data.errors || (data.details && data.details.errors) || (data.raw && data.raw.errors));

    if (Array.isArray(errors)) {
      const messages = errors
        .map((err) => (err && err.message) || err)
        .filter(Boolean)
        .join(', ');
      if (messages) return messages;
    }

    if (typeof errors === 'string' && errors.trim()) {
      return errors;
    }

    return fallback;
  }

  const HIDE_SELECTORS = [
    'form[action*="/cart"] [name="checkout"]',
    'button[name="checkout"]',
    'input[name="checkout"]',
    '.additional-checkout-buttons',
    '.shopify-payment-button',
    '[data-shopify="dynamic-checkout"]'
  ];

  const INVOICE_LOCK_KEY = 'aufrechnung_in_progress';
  const INVOICE_DATE_KEY = 'aufrechnung_delivery_date';
  const INVOICE_DONE_KEY = 'aufrechnung_completed';
  const APARTMENT_STORAGE_KEY = 'laufendeLieferungApartment';

  const validationCache = new Map();
  const inflightValidationRequests = new Map();

  function nowLocalNoon(d = new Date()) {
    const x = new Date(d);
    x.setHours(12, 0, 0, 0);
    return x;
  }

  function isoFromDate(d) {
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  }

  function dateFromISO(iso) {
    const [y, m, d] = String(iso || '').split('-').map(Number);
    if (!y || !m || !d) return null;
    const dt = new Date(y, m - 1, d);
    dt.setHours(12, 0, 0, 0);
    return Number.isNaN(dt.getTime()) ? null : dt;
  }

  function parseBlockedDates(text) {
    return parseBlockedDateList(text);
  }

  function parseBlockedWeekdays(text) {
    return String(text || '')
      .split(',')
      .map(s => s.trim())
      .filter(Boolean)
      .map(n => Number(n))
      .filter(n => !Number.isNaN(n));
  }

  function parseCutoffTime(text) {
    const m = String(text || '')
      .trim()
      .replace('.', ':')
      .match(/^(\d{1,2}):(\d{2})(?:\s*([ap])\.?m\.?)?$/i);
    if (!m) return { hour: 21, minute: 0 };

    let hour = Number(m[1]);
    const meridiem = String(m[3] || '').toLowerCase();
    if (meridiem === 'p' && hour < 12) hour += 12;
    if (meridiem === 'a' && hour === 12) hour = 0;

    return {
      hour: Math.max(0, Math.min(23, hour)),
      minute: Math.max(0, Math.min(59, Number(m[2])))
    };
  }

  function isBlockedDate(d, blockedDates, blockedWeekdays) {
    const iso = isoFromDate(d);
    return blockedDates.includes(iso) || blockedWeekdays.includes(d.getDay());
  }

  function findNextAllowedDate(startDate, blockedDates, blockedWeekdays) {
    const d = nowLocalNoon(startDate);
    for (let i = 0; i < 370; i++) {
      if (!isBlockedDate(d, blockedDates, blockedWeekdays)) return d;
      d.setDate(d.getDate() + 1);
    }
    return nowLocalNoon(startDate);
  }

  function computeMinDate(cutoffText, blockedDates, blockedWeekdays) {
    const now = new Date();
    const cutoff = parseCutoffTime(cutoffText);

    const base = nowLocalNoon(now);
    const afterCutoff =
      now.getHours() > cutoff.hour ||
      (now.getHours() === cutoff.hour && now.getMinutes() >= cutoff.minute);

    base.setDate(base.getDate() + (afterCutoff ? 2 : 1));
    return findNextAllowedDate(base, blockedDates, blockedWeekdays);
  }

  function msg(text, replacements) {
    let out = String(text || '');
    Object.keys(replacements || {}).forEach((key) => {
      out = out.replaceAll(`[${key}]`, String(replacements[key]));
    });
    return out;
  }

  function ensureModal() {
    let backdrop = document.querySelector('[data-dd-modal-backdrop]');
    let modal = document.querySelector('[data-dd-modal]');

    if (backdrop && modal) return { backdrop, modal };

    backdrop = document.createElement('div');
    backdrop.setAttribute('data-dd-modal-backdrop', '');
    backdrop.style.cssText = [
      'display:none',
      'position:fixed',
      'inset:0',
      'background:rgba(0,0,0,0.45)',
      'z-index:9998'
    ].join(';');

    modal = document.createElement('div');
    modal.setAttribute('data-dd-modal', '');
    modal.style.cssText = [
      'display:none',
      'position:fixed',
      'left:50%',
      'top:50%',
      'transform:translate(-50%,-50%)',
      'width:min(92vw,520px)',
      'background:#fff',
      'color:#111',
      'border-radius:14px',
      'padding:24px',
      'box-shadow:0 20px 60px rgba(0,0,0,0.25)',
      'z-index:9999'
    ].join(';');

    modal.innerHTML = `
      <div style="display:flex;justify-content:space-between;align-items:center;gap:12px;">
        <h3 data-dd-modal-title style="margin:0;font-size:1.15rem;"></h3>
        <button type="button" data-dd-modal-close aria-label="Schließen" style="border:0;background:transparent;font-size:1.4rem;cursor:pointer;">×</button>
      </div>
      <div data-dd-modal-message style="margin-top:14px;line-height:1.5;"></div>
      <div style="margin-top:20px;display:flex;justify-content:flex-end;">
        <button type="button" data-dd-modal-ok style="padding:10px 16px;cursor:pointer;"></button>
      </div>
    `;

    document.body.appendChild(backdrop);
    document.body.appendChild(modal);

    const close = () => {
      backdrop.style.display = 'none';
      modal.style.display = 'none';
    };

    backdrop.addEventListener('click', close);
    modal.querySelector('[data-dd-modal-close]').addEventListener('click', close);
    modal.querySelector('[data-dd-modal-ok]').addEventListener('click', close);

    return { backdrop, modal };
  }

  function showModal(root, title, message, buttonText) {
    const { backdrop, modal } = ensureModal();
    modal.querySelector('[data-dd-modal-title]').textContent = title || 'Hinweis';
    modal.querySelector('[data-dd-modal-message]').textContent = message || '';
    modal.querySelector('[data-dd-modal-ok]').textContent = buttonText || 'OK';
    backdrop.style.display = 'block';
    modal.style.display = 'block';
  }

  function setStatus(root, text) {
    const el = root.querySelector('[data-dd-status]');
    if (el) el.textContent = text || '';
  }

  function normalizeAddressValue(v) {
    return String(v || '').trim().toLowerCase();
  }

  function getAddressFingerprint(address) {
    if (!address) return '';
    return [
      normalizeAddressValue(address.id),
      normalizeAddressValue(address.first_name),
      normalizeAddressValue(address.last_name),
      normalizeAddressValue(address.company),
      normalizeAddressValue(address.address1),
      normalizeAddressValue(address.address2),
      normalizeAddressValue(address.zip),
      normalizeAddressValue(address.city),
      normalizeAddressValue(address.province),
      normalizeAddressValue(address.country),
      normalizeAddressValue(address.phone)
    ].join('|');
  }

  function getSelectedAddress(select) {
    if (!select) return null;
    const option = select.options[select.selectedIndex];
    if (!option) return null;

    return {
      id: option.dataset.id || '',
      first_name: option.dataset.firstName || '',
      last_name: option.dataset.lastName || '',
      company: option.dataset.company || '',
      address1: option.dataset.address1 || '',
      address2: option.dataset.address2 || '',
      zip: option.dataset.zip || '',
      city: option.dataset.city || '',
      province: option.dataset.province || '',
      country: option.dataset.country || '',
      phone: option.dataset.phone || ''
    };
  }

  function getStoredApartment() {
    try {
      const raw = window.localStorage.getItem(APARTMENT_STORAGE_KEY);
      if (!raw) return null;

      const parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== 'object') return null;
      if (!parsed.address1 || !parsed.city) return null;

      return parsed;
    } catch (error) {
      console.warn('Ferienwohnung aus localStorage konnte nicht gelesen werden.', error);
      return null;
    }
  }

  function apartmentToAddress(apartment) {
    if (!apartment) return null;

    return {
      id: apartment.id || apartment.slug || '',
      first_name: '',
      last_name: '',
      company: apartment.title || '',
      address1: apartment.address1 || '',
      address2: apartment.address2 || '',
      zip: apartment.zip || '',
      city: apartment.city || '',
      province: apartment.province || '',
      country: apartment.country || '',
      phone: ''
    };
  }

  function getApartmentCartAttributes(apartment) {
    const address = apartmentToAddress(apartment);
    if (!address) return {};

    return {
      tapp_address_id: address.id || '',
      tapp_first_name: '',
      tapp_last_name: '',
      tapp_company: address.company || '',
      tapp_address1: address.address1 || '',
      tapp_address2: address.address2 || '',
      tapp_address_city: address.city || '',
      tapp_address_zip: address.zip || '',
      tapp_address_label: apartment.title || '',
      tapp_country: address.country || '',
      tapp_province: address.province || '',
      tapp_phone: '',
      tapp_lat: '',
      tapp_lng: '',
      tapp_address_source: 'ferienwohnung',
      tapp_apartment_id: apartment.id || '',
      tapp_apartment_slug: apartment.slug || '',
      tapp_apartment_title: apartment.title || ''
    };
  }

  async function buildCheckoutUrl(address) {
    const cart = await getCartJson();
    const items = Array.isArray(cart && cart.items) ? cart.items : [];
    const permalinkItems = items
      .map(item => {
        const variantId = Number(item && item.variant_id);
        const quantity = Number(item && item.quantity);
        return variantId > 0 && quantity > 0 ? `${variantId}:${quantity}` : '';
      })
      .filter(Boolean);

    if (!permalinkItems.length) {
      throw new Error('Warenkorb ist leer');
    }

    const url = new URL(
      ROOT.replace(/\/?$/, '/') + 'cart/' + permalinkItems.join(','),
      window.location.origin
    );

    const fields = {
      first_name: address.first_name || '',
      last_name: address.last_name || '',
      address1: address.address1 || '',
      address2: address.address2 || '',
      zip: address.zip || '',
      city: address.city || '',
      province: address.province || '',
      country: address.country || ''
    };

    Object.entries(fields).forEach(([key, value]) => {
      if (String(value).trim() !== '') {
        url.searchParams.set(`checkout[shipping_address][${key}]`, value);
      }
    });

    const attributes = cart && cart.attributes && typeof cart.attributes === 'object'
      ? cart.attributes
      : {};

    Object.entries(attributes).forEach(([key, value]) => {
      url.searchParams.set(`attributes[${key}]`, value == null ? '' : String(value));
    });

    return url.toString();
  }

  async function updateCartAttributes(attributes) {
    const url = storefrontPath('cart/update.js');

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ attributes }),
      credentials: 'same-origin'
    });

    if (!response.ok) {
      throw new Error('Cart attributes could not be updated');
    }

    return response.json().catch(() => null);
  }

  async function validateAddressViaProxy(root, address) {
    const appProxyUrl = String(root.dataset.ddAppProxyUrl || '').trim();

    if (!appProxyUrl) {
      return {
        ok: false,
        inside: false,
        message: 'Keine Proxy-URL gesetzt'
      };
    }

    const fingerprint = getAddressFingerprint(address);

    if (validationCache.has(fingerprint)) {
      return validationCache.get(fingerprint);
    }

    if (inflightValidationRequests.has(fingerprint)) {
      return inflightValidationRequests.get(fingerprint);
    }

    const promise = (async () => {
      const body = JSON.stringify({
        address1: address.address1 || '',
        address2: address.address2 || '',
        zip: address.zip || '',
        city: address.city || '',
        province: address.province || '',
        country: address.country || ''
      });

      let lastFailure = null;

      for (const url of appProxyUrlCandidates(appProxyUrl)) {
        try {
          const response = await fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body,
            credentials: 'same-origin'
          });

          const raw = await response.text();
          let json = null;

          try {
            json = JSON.parse(raw);
          } catch (e) {
            lastFailure = {
              ok: false,
              inside: false,
              message: root.dataset.ddMsgGeocodeFailed || 'Die Adresse konnte nicht geprÃ¼ft werden.',
              url,
              status: response.status,
              raw: raw.slice(0, 200)
            };
            console.warn('Delivery address proxy returned non-JSON', lastFailure);
            continue;
          }

          if (!response.ok) {
            lastFailure = {
              ok: false,
              inside: false,
              message: json.message || ('HTTP ' + response.status),
              url,
              status: response.status,
              response: json
            };
            console.warn('Delivery address proxy returned HTTP error', lastFailure);
            continue;
          }

          validationCache.set(fingerprint, json);
          return json;
        } catch (error) {
          lastFailure = {
            ok: false,
            inside: false,
            message: root.dataset.ddMsgGeocodeFailed || 'Die Adresse konnte nicht geprÃ¼ft werden.',
            url,
            error
          };
          console.warn('Delivery address proxy request failed', lastFailure);
        }
      }

      return lastFailure || {
        ok: false,
        inside: false,
        message: root.dataset.ddMsgGeocodeFailed || 'Die Adresse konnte nicht geprÃ¼ft werden.'
      };
    })();

    inflightValidationRequests.set(fingerprint, promise);

    try {
      return await promise;
    } finally {
      inflightValidationRequests.delete(fingerprint);
    }
  }

  async function getCartJson() {
    const res = await fetch(storefrontPath('cart.js'), {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    });

    if (!res.ok) throw new Error('Cart konnte nicht geladen werden');
    return res.json();
  }

  function hideNativeCheckoutButtons(root) {
    if (String(root.dataset.ddHideNativeCheckout) !== 'true') return;

    HIDE_SELECTORS.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => {
        if (!root.contains(el)) {
          el.classList.add('dd-hidden-checkout');
        }
      });
    });
  }

  function setInvoiceLock(value) {
    if (value) {
      sessionStorage.setItem(INVOICE_LOCK_KEY, '1');
    } else {
      sessionStorage.removeItem(INVOICE_LOCK_KEY);
    }
  }

  function hasInvoiceLock() {
    return sessionStorage.getItem(INVOICE_LOCK_KEY) === '1';
  }

  function saveInvoiceDeliveryDate(dateIso) {
    if (dateIso) sessionStorage.setItem(INVOICE_DATE_KEY, dateIso);
  }

  function markInvoiceCompleted() {
    sessionStorage.setItem(INVOICE_DONE_KEY, '1');
    sessionStorage.removeItem(INVOICE_LOCK_KEY);
  }

  function wasInvoiceCompleted() {
    return sessionStorage.getItem(INVOICE_DONE_KEY) === '1';
  }

  function resetInvoiceCompletedFlag() {
    sessionStorage.removeItem(INVOICE_DONE_KEY);
  }

  function ensureInvoiceOverlay() {
    let ov = document.getElementById('rechnung-wait-overlay');
    if (ov) return ov;

    ov = document.createElement('div');
    ov.id = 'rechnung-wait-overlay';
    ov.setAttribute('aria-hidden', 'true');
    ov.style.position = 'fixed';
    ov.style.inset = '0';
    ov.style.zIndex = '9999';
    ov.style.display = 'none';
    ov.style.alignItems = 'center';
    ov.style.justifyContent = 'center';
    ov.style.background = 'rgba(255,255,255,0.65)';
    ov.style.backdropFilter = 'blur(2px)';

    const I18N = window.AUFRECHNUNG_I18N || {};
    const waitTitle = I18N.waitTitle || 'Bitte warten …';
    const waitText = I18N.waitText || 'Wir erstellen deine Bestellung auf Rechnung.';

    ov.innerHTML = `
      <div style="
        padding:16px 18px;
        border-radius:14px;
        background:#fff;
        box-shadow:0 10px 30px rgba(0,0,0,.12);
        display:flex;
        gap:12px;
        align-items:center;
        font:14px/1.3 system-ui;
        max-width:420px;
        margin:16px;
      ">
        <div style="
          width:18px;height:18px;border-radius:999px;
          border:2px solid rgba(0,0,0,.25);
          border-top-color:rgba(0,0,0,.75);
          animation: rechnungSpin .8s linear infinite;
          flex:0 0 auto;
        "></div>
        <div>
          <div style="font-weight:600;">${waitTitle}</div>
          <div style="opacity:.75;">${waitText}</div>
        </div>
      </div>
    `;

    if (!document.getElementById('rechnung-wait-style')) {
      const style = document.createElement('style');
      style.id = 'rechnung-wait-style';
      style.textContent = '@keyframes rechnungSpin { to { transform: rotate(360deg); } }';
      document.head.appendChild(style);
    }

    document.body.appendChild(ov);
    return ov;
  }

  function showInvoiceOverlay() {
    const overlay = ensureInvoiceOverlay();
    overlay.style.display = 'flex';
    overlay.setAttribute('aria-hidden', 'false');
  }

  function hideInvoiceOverlay() {
    const overlay = document.getElementById('rechnung-wait-overlay');
    if (!overlay) return;
    overlay.style.display = 'none';
    overlay.setAttribute('aria-hidden', 'true');
  }

  function setButtonsDisabled(checkoutBtn, checkoutRechnungBtn, disabled, rechnungAllowed) {
    if (checkoutBtn) checkoutBtn.disabled = !!disabled;
    if (checkoutRechnungBtn) {
      if (disabled) {
        checkoutRechnungBtn.disabled = true;
      } else {
        checkoutRechnungBtn.disabled = !rechnungAllowed;
      }
    }
  }

  //Items sperren nach datum!!!!!!!!!!!!!
  function parseJsonStringArray(text) {
  const raw = String(text || '').trim();
  if (!raw) return [];

  try {
    const parsed = JSON.parse(raw);
    if (Array.isArray(parsed)) {
      return parsed
        .map(v => String(v).trim().toLowerCase())
        .filter(Boolean);
    }
    if (parsed == null) return [];
  } catch (e) {}

  if (raw.toLowerCase() === 'null' || raw.toLowerCase() === 'undefined') return [];

  return raw
    .split(/[,\n;|]+/)
    .map(s => s.replace(/^["']|["']$/g, '').trim().toLowerCase())
    .filter(Boolean);
}

const WEEKDAY_INDEX_BY_NAME = {
  sonntag: 0, so: 0, sun: 0, sunday: 0, domenica: 0, dom: 0,
  montag: 1, mo: 1, mon: 1, monday: 1, lunedi: 1, lun: 1,
  dienstag: 2, di: 2, tue: 2, tues: 2, tuesday: 2, martedi: 2, mar: 2,
  mittwoch: 3, mi: 3, wed: 3, wednesday: 3, mercoledi: 3, mer: 3,
  donnerstag: 4, do: 4, thu: 4, thur: 4, thurs: 4, thursday: 4, giovedi: 4, gio: 4,
  freitag: 5, fr: 5, fri: 5, friday: 5, venerdi: 5, ven: 5,
  samstag: 6, sa: 6, sat: 6, saturday: 6, sabato: 6, sab: 6
};

function normalizeMachineToken(value) {
  return String(value == null ? '' : value)
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[\s._-]+/g, '');
}

function normalizeBlockedWeekday(value) {
  const token = normalizeMachineToken(value);
  if (/^[0-6]$/.test(token)) return Number(token);
  return Object.prototype.hasOwnProperty.call(WEEKDAY_INDEX_BY_NAME, token)
    ? WEEKDAY_INDEX_BY_NAME[token]
    : null;
}

function parseBlockedWeekdayList(value) {
  return Array.from(new Set(
    parseJsonStringArray(value)
      .map(normalizeBlockedWeekday)
      .filter(day => day != null)
  ));
}

function normalizeBlockedDate(value) {
  const raw = String(value == null ? '' : value).trim();
  if (!raw) return '';

  let year;
  let month;
  let day;
  let match = raw.match(/^(\d{4})[-/.](\d{1,2})[-/.](\d{1,2})$/);
  if (match) {
    year = Number(match[1]);
    month = Number(match[2]);
    day = Number(match[3]);
  } else {
    match = raw.match(/^(\d{1,2})[-/.](\d{1,2})[-/.](\d{4})$/);
    if (!match) return '';
    day = Number(match[1]);
    month = Number(match[2]);
    year = Number(match[3]);
  }

  const date = new Date(Date.UTC(year, month - 1, day));
  if (
    date.getUTCFullYear() !== year ||
    date.getUTCMonth() !== month - 1 ||
    date.getUTCDate() !== day
  ) return '';

  return `${String(year).padStart(4, '0')}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
}

function parseBlockedDateList(value) {
  return Array.from(new Set(
    parseJsonStringArray(value)
      .map(normalizeBlockedDate)
      .filter(Boolean)
  ));
}

function getCartItemRestrictions() {
  return Array.from(
    document.querySelectorAll('.cart-items__table-row[data-line-index]')
  ).map((el) => ({
    el,
    lineIndex: Number(el.getAttribute('data-line-index') || '0'),
    title: el.getAttribute('data-product-title') || 'Produkt',
    blockedWeekdays: parseBlockedWeekdayList(el.getAttribute('data-blocked-weekdays') || ''),
    blockedDates: parseBlockedDateList(el.getAttribute('data-blocked-dates') || '')
  }));
}

function clearCartItemRestrictionState() {
  document.querySelectorAll('[data-line-index][data-product-title]').forEach((el) => {
    el.classList.remove('dd-item-blocked');

    const msg = el.querySelector('[data-dd-item-warning]');
    if (msg) {
      msg.textContent = '';
      msg.hidden = true;
    }
  });
}

function validateCartItemsForDeliveryDate(deliveryDateIso) {
  clearCartItemRestrictionState();
console.log('deliveryDateIso', deliveryDateIso);
  console.log('selected weekday', dateFromISO(deliveryDateIso)?.getDay());
console.log('restrictions', getCartItemRestrictions());
  const selectedDate = dateFromISO(deliveryDateIso);
  if (!selectedDate) {
    return { ok: false, conflicts: [], message: 'Ungültiges Lieferdatum.' };
  }

  const weekdayIndex = selectedDate.getDay();
  const iso = isoFromDate(selectedDate).toLowerCase();
  const conflicts = [];

  getCartItemRestrictions().forEach((item) => {
    const isBlocked =
      item.blockedWeekdays.includes(weekdayIndex) ||
      item.blockedDates.includes(iso);

    if (!isBlocked) return;

    item.el.classList.add('dd-item-blocked');

    const warningEl = item.el.querySelector('[data-dd-item-warning]');
    if (warningEl) {
      warningEl.hidden = false;
      warningEl.textContent = 'Für den gewählten Liefertag nicht verfügbar.';
    }

    conflicts.push(item);
  });

  if (conflicts.length) {
    return {
      ok: false,
      conflicts,
      message:
        'Einige Produkte sind für den gewählten Liefertag nicht verfügbar: ' +
        conflicts.map(x => x.title).join(', ')
    };
  }

  return { ok: true, conflicts: [], message: '' };
}
  //Items sperren nach datum!!!!!!!!!!!!!


  function setupRoot(root) {
    if (!root || root.dataset.ddInit === '1') return;
    root.dataset.ddInit = '1';

    const input = root.querySelector('[data-dd-input]');
    const addressSelect = root.querySelector('[data-dd-address-select]');
    const addressWrap = root.querySelector('.dp-address-wrap');
    const loginRequired = root.querySelector('.dp-login-required');
    const apartmentNote = root.querySelector('[data-dd-apartment-note]');
    const checkoutBtn = root.querySelector('[data-dd-checkout]');
    const checkoutRechnungBtn = root.querySelector('[data-dd-checkout-rechnung]');
    const rechnungNote = root.querySelector('.dp-rechnung-note');
    const rechnungAllowed = String(root.dataset.ddRechnungOk) === 'true';
    const customerTappId = String(root.dataset.ddCustomerTappId || '').trim();
    const apartment = getStoredApartment();
    const apartmentAddress = apartmentToAddress(apartment);
    const isApartmentCheckout = !!apartmentAddress;

    let invoiceSubmitting = false;
    let normalSubmitting = false;

    if (!input || (!checkoutBtn && !checkoutRechnungBtn)) return;

    if (apartmentAddress) {
      if (addressWrap) addressWrap.hidden = true;
      if (loginRequired) loginRequired.hidden = true;
      if (apartmentNote) apartmentNote.hidden = false;
      if (checkoutRechnungBtn) checkoutRechnungBtn.hidden = true;
      if (rechnungNote) rechnungNote.hidden = true;
    }

    const blockedDates = parseBlockedDates(root.dataset.ddDates);
    const blockedWeekdays = parseBlockedWeekdays(root.dataset.ddWeekdays);
    const cutoffText = root.dataset.ddCutoff || '21:00';

    const modalTitle = root.dataset.ddModalTitle || 'Hinweis';
    const modalButton = root.dataset.ddModalButton || 'OK';

    const minDate = computeMinDate(cutoffText, blockedDates, blockedWeekdays);
    const minIso = isoFromDate(minDate);
    input.min = minIso;

    window.addEventListener('pageshow', function (event) {
      const navEntry = performance.getEntriesByType('navigation')[0];
      if (event.persisted || navEntry?.type === 'back_forward') {
        hideInvoiceOverlay();
        setButtonsDisabled(checkoutBtn, checkoutRechnungBtn, false, rechnungAllowed);
        setStatus(root, '');
        setInvoiceLock(false);
        invoiceSubmitting = false;
        normalSubmitting = false;
      }
    });

    window.addEventListener('pagehide', function () {
      hideInvoiceOverlay();
    });

    if (!input.value) {
      input.value = minIso;
    }
    validateCartItemsForDeliveryDate(input.value);

    input.addEventListener('change', function () {
      const selected = dateFromISO(input.value);

      if (!selected) {
        const nextDate = findNextAllowedDate(minDate, blockedDates, blockedWeekdays);
        input.value = isoFromDate(nextDate);
        showModal(root, modalTitle, root.dataset.ddMsgInvalid || 'Ungültiges Datum.', modalButton);
        return;
      }

      if (selected < minDate || isBlockedDate(selected, blockedDates, blockedWeekdays)) {
        const nextDate = findNextAllowedDate(
          selected < minDate ? minDate : selected,
          blockedDates,
          blockedWeekdays
        );

        input.value = isoFromDate(nextDate);

        showModal(
          root,
          modalTitle,
          selected < minDate
            ? msg(root.dataset.ddMsgCutoff, { cutoff: cutoffText })
            : (root.dataset.ddMsgBlocked || 'Datum nicht verfügbar.'),
          modalButton
        );
      }
      validateCartItemsForDeliveryDate(input.value);
    });

    if (addressSelect) {
      addressSelect.addEventListener('change', function () {
        setStatus(root, '');
      });
    }

    async function prepareCheckoutData() {
      const deliveryDate = String(input.value || '').trim();
      const selectedDate = dateFromISO(deliveryDate);

      //items nach wochentag sperren
      const cartItemsCheck = validateCartItemsForDeliveryDate(deliveryDate);

      if (!cartItemsCheck.ok) {
        showModal(
          root,
          modalTitle,
          cartItemsCheck.message,
          modalButton
        );
        return null;
      }
      //items nach wochentag sperren

      if (!deliveryDate) {
        showModal(
          root,
          modalTitle,
          (window.AUFRECHNUNG_I18N && window.AUFRECHNUNG_I18N.needDate)
            || root.dataset.ddMsgEmpty
            || 'Bitte wähle ein Lieferdatum.',
          modalButton
        );
        return null;
      }

      if (!selectedDate) {
        const nextDate = findNextAllowedDate(minDate, blockedDates, blockedWeekdays);
        input.value = isoFromDate(nextDate);
        showModal(root, modalTitle, root.dataset.ddMsgInvalid || 'Ungültiges Datum.', modalButton);
        return null;
      }

      if (selectedDate < minDate || isBlockedDate(selectedDate, blockedDates, blockedWeekdays)) {
        const nextDate = findNextAllowedDate(
          selectedDate < minDate ? minDate : selectedDate,
          blockedDates,
          blockedWeekdays
        );

        input.value = isoFromDate(nextDate);

        showModal(
          root,
          modalTitle,
          selectedDate < minDate
            ? msg(root.dataset.ddMsgCutoff, { cutoff: cutoffText })
            : (root.dataset.ddMsgBlocked || 'Datum nicht verfügbar.'),
          modalButton
        );
        return null;
      }

      if (apartmentAddress) {
        setStatus(root, 'Ferienwohnung als Lieferadresse aktiv.');

        await updateCartAttributes({
          delivery_date: deliveryDate,
          tapp_id: '',
          ...getApartmentCartAttributes(apartment),
          tapp_is_guest: isApartmentCheckout ? 'ja' : 'nein'
        });

        return {
          deliveryDate,
          address: apartmentAddress,
          validation: {
            ok: true,
            inside: true,
            label: apartment.title || ''
          }
        };
      }

      if (!addressSelect) {
        const isCustomer =
          String(root.dataset.ddIsCustomer || '') === 'true' ||
          !!root.querySelector('[data-dd-no-addresses]');
        showModal(
          root,
          modalTitle,
          isCustomer
            ? (root.dataset.ddMsgNoAddress || 'Bitte füge zuerst eine Lieferadresse hinzu.')
            : (root.dataset.ddMsgLogin || 'Bitte melde dich zuerst an.'),
          modalButton
        );
        return null;
      }

      const address = getSelectedAddress(addressSelect);

      if (!address || !address.address1 || !address.city) {
        showModal(
          root,
          modalTitle,
          root.dataset.ddMsgNoAddress || 'Bitte füge zuerst eine Lieferadresse hinzu.',
          modalButton
        );
        return null;
      }

      setStatus(root, root.dataset.ddMsgChecking || 'Adresse wird geprüft ...');

      const validation = await validateAddressViaProxy(root, address);

      if (!validation.ok) {
        showModal(
          root,
          modalTitle,
          validation.message || root.dataset.ddMsgGeocodeFailed || 'Die Adresse konnte nicht geprüft werden.',
          modalButton
        );
        setStatus(root, '');
        return null;
      }

      if (!validation.inside) {
        showModal(
          root,
          modalTitle,
          validation.message || root.dataset.ddMsgOutsideArea || 'Diese Adresse liegt außerhalb unseres Liefergebiets.',
          modalButton
        );
        setStatus(root, '');
        return null;
      }

      setStatus(root, root.dataset.ddMsgInsideArea || 'Adresse liegt im Liefergebiet.');

      await updateCartAttributes({
        delivery_date: deliveryDate,
        tapp_id: customerTappId,
        tapp_address_id: address.id || '',
        tapp_first_name: address.first_name || '',
        tapp_last_name: address.last_name || '',
        tapp_company: address.company || '',
        tapp_address1: address.address1 || '',
        tapp_address2: address.address2 || '',
        tapp_address_city: address.city || '',
        tapp_address_zip: address.zip || '',
        tapp_address_label: validation.label || '',
        tapp_country: address.country || '',
        tapp_province: address.province || '',
        tapp_phone: address.phone || '',
        tapp_lat: validation.lat != null ? String(validation.lat) : '',
        tapp_lng: validation.lng != null ? String(validation.lng) : '',
        tapp_address_source: 'customer',
        tapp_is_guest: isApartmentCheckout ? 'ja' : 'nein',
        tapp_apartment_id: '',
        tapp_apartment_slug: '',
        tapp_apartment_title: ''
      });

      return { deliveryDate, address, validation };
    }

    async function handleNormalCheckout() {
      if (!checkoutBtn || normalSubmitting || invoiceSubmitting || hasInvoiceLock()) return;

      normalSubmitting = true;
      setButtonsDisabled(checkoutBtn, checkoutRechnungBtn, true, rechnungAllowed);
      setStatus(root, '');

      try {
        const prepared = await prepareCheckoutData();
        if (!prepared) {
          return;
        }

        window.location.href = apartmentAddress
          ? await buildCheckoutUrl(apartmentAddress)
          : storefrontPath('checkout');
      } catch (err) {
        console.error('Normal checkout error:', err);
        showModal(
          root,
          modalTitle,
          root.dataset.ddMsgGeocodeFailed || 'Die Adresse konnte nicht geprüft werden.',
          modalButton
        );
        setStatus(root, '');
      } finally {
        normalSubmitting = false;
        setButtonsDisabled(checkoutBtn, checkoutRechnungBtn, false, rechnungAllowed);
      }
    }

    async function handleInvoiceCheckout() {
      if (!checkoutRechnungBtn || invoiceSubmitting || normalSubmitting || hasInvoiceLock()) {
        return;
      }

      const I18N = window.AUFRECHNUNG_I18N || {};

      invoiceSubmitting = true;
      setInvoiceLock(true);
      setButtonsDisabled(checkoutBtn, checkoutRechnungBtn, true, rechnungAllowed);
      showInvoiceOverlay();
      setStatus(root, '');

      try {
        const prepared = await prepareCheckoutData();
        if (!prepared) {
          hideInvoiceOverlay();
          setInvoiceLock(false);
          invoiceSubmitting = false;
          setButtonsDisabled(checkoutBtn, checkoutRechnungBtn, false, rechnungAllowed);
          return;
        }

        saveInvoiceDeliveryDate(prepared.deliveryDate);

        const cart = await getCartJson();

        const form = new FormData();
        form.append('payload', JSON.stringify({ cart }));
        form.append('delivery_date', prepared.deliveryDate);

        const res = await fetch('/apps/aufrechnung', {
          method: 'POST',
          body: form,
          credentials: 'same-origin'
        });

        const text = await res.text();

        let data = {};
        try {
          data = JSON.parse(text);
        } catch (e) {
          data = {};
        }

        if (!res.ok) {
          throw new Error(checkoutErrorMessage(data, (I18N.httpError || 'Anfrage fehlgeschlagen') + ' (HTTP ' + res.status + ')'));
        }

        if (data.ok === true) {
          markInvoiceCompleted();

          if (data.redirectUrl) {
            const url = new URL(normalizeStorefrontUrl(data.redirectUrl), window.location.origin);
            url.searchParams.set('delivery_date', prepared.deliveryDate);
            window.location.href = url.toString();
            return;
          }

          window.location.href = storefrontPath('pages/danke-rechnung');
          return;
        }

        throw new Error(checkoutErrorMessage(data, I18N.createErr || 'Bestellung auf Rechnung konnte nicht erstellt werden.'));
      } catch (e) {
        console.error('Invoice checkout error:', e);

        if (wasInvoiceCompleted()) {
          if (window.location.pathname !== new URL(storefrontPath('pages/danke-rechnung'), window.location.origin).pathname) {
            window.location.href = storefrontPath('pages/danke-rechnung');
            return;
          }
        }

        hideInvoiceOverlay();
        setInvoiceLock(false);
        invoiceSubmitting = false;
        setButtonsDisabled(checkoutBtn, checkoutRechnungBtn, false, rechnungAllowed);

        showModal(
          root,
          modalTitle,
          e && e.message
            ? e.message
            : ((window.AUFRECHNUNG_I18N && window.AUFRECHNUNG_I18N.createErr)
              || 'Bestellung auf Rechnung konnte nicht erstellt werden.'),
          modalButton
        );
      }
    }

    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', handleNormalCheckout);
    }

    if (checkoutRechnungBtn) {
      checkoutRechnungBtn.addEventListener('click', handleInvoiceCheckout);
    }

    hideNativeCheckoutButtons(root);
  }

  function initAll() {
    document.querySelectorAll('[data-dd-root]').forEach(setupRoot);
  }

  document.addEventListener('DOMContentLoaded', initAll);

  const mo = new MutationObserver(() => initAll());
  mo.observe(document.documentElement, { childList: true, subtree: true });

  //document.addEventListener('click', function (e) {
    //const input = e.target.closest('.dp-input--date-topline');
    //if (input && typeof input.showPicker === 'function') {
      //input.showPicker();
    //}
  //});

  if (wasInvoiceCompleted() && window.location.pathname !== new URL(storefrontPath('pages/danke-rechnung'), window.location.origin).pathname) {
    resetInvoiceCompletedFlag();
  }
})();
